import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Sun, Moon, LogOut } from 'lucide-react'
import { useAuth } from '../hooks/useAuth'
import { useTheme } from '../hooks/useTheme'
import ProfileAvatar from './ProfileAvatar'

const Header: React.FC = () => {
  const { user, logout } = useAuth()
  const { theme, toggleTheme } = useTheme()
  const location = useLocation()

  // Check if this is a share page (7-character hash) or 404 page
  const isSharePage = location.pathname.length === 8 && 
    location.pathname.substring(1).match(/^[a-zA-Z0-9]{7}$/)
  const is404Page = location.pathname === '/404'

  return (
    <header className="bg-white dark:bg-dark-background shadow-custom-light py-4 px-6">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <img 
              src="https://host46.ssl-net.net/stoeger_film/dateien/stoeger.film_logo-SVG.svg" 
              alt="stoeger.film Logo" 
              className={`h-8 ${theme === 'dark' ? 'filter invert' : ''}`}
            />
          </Link>
        </div>
        
        <div className="flex items-center space-x-4">
          {user && !isSharePage && !is404Page && (
            <>
              <ProfileAvatar user={user} />
              <button 
                onClick={logout}
                className="btn btn-outline flex items-center"
                aria-label="Logout"
              >
                <LogOut size={18} className="mr-2" />
                Logout
              </button>
            </>
          )}
          
          <button 
            onClick={toggleTheme} 
            className="p-2 rounded-full hover:bg-[var(--color-accent)] hover:bg-opacity-20 transition-all"
            aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          >
            {theme === 'light' ? (
              <Moon size={20} className="text-[var(--color-primary)]" />
            ) : (
              <Sun size={20} className="text-[var(--color-primary)]" />
            )}
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header